export const FETCH_CUSTOM_REPORTS_LIST = 'FETCH_CUSTOM_REPORTS_LIST';
export const FETCH_CUSTOM_REPORTS_LIST_SUCCESS = 'FETCH_CUSTOM_REPORTS_LIST_SUCCESS';
export const FETCH_CUSTOM_REPORTS_LIST_FAILURE = 'FETCH_CUSTOM_REPORTS_LIST_FAILURE';

export const SELECT_CUSTOM_REPORT = 'SELECT_CUSTOM_REPORT';

export const FETCH_CUSTOM_REPORTS_PARAMS = 'FETCH_CUSTOM_REPORTS_PARAMS';
export const FETCH_CUSTOM_REPORTS_PARAMS_SUCCESS = 'FETCH_CUSTOM_REPORTS_PARAMS_SUCCESS';
export const FETCH_CUSTOM_REPORTS_PARAMS_FAILURE = 'FETCH_CUSTOM_REPORTS_PARAMS_FAILURE';

export const RUN_CUSTOM_REPORT = 'RUN_CUSTOM_REPORT';
export const RUN_CUSTOM_REPORT_SUCCESS = 'RUN_CUSTOM_REPORT_SUCCESS';
export const RUN_CUSTOM_REPORT_FAILURE = 'RUN_CUSTOM_REPORT_FAILURE';

export const FETCH_CUSTOM_REPORT_SET = 'FETCH_CUSTOM_REPORT_SET';
export const FETCH_CUSTOM_REPORT_SET_SUCCESS = 'FETCH_CUSTOM_REPORT_SET_SUCCESS';
export const FETCH_CUSTOM_REPORT_SET_FAILURE = 'FETCH_CUSTOM_REPORT_SET_FAILURE';

export const UPDATE_QUERY_PARAMS = 'UPDATE_QUERY_PARAMS';

export const RESET_CUSTOM_REPORT = 'RESET_CUSTOM_REPORT';

export const VERIFY_PARAM_OPTIONS_QUERY = 'VERIFY_PARAM_OPTIONS_QUERY';
export const VERIFY_PARAM_OPTIONS_QUERY_SUCCESS = 'VERIFY_PARAM_OPTIONS_QUERY_SUCCESS';
export const VERIFY_PARAM_OPTIONS_QUERY_FAILURE = 'VERIFY_PARAM_OPTIONS_QUERY_FAILURE';
